export const featureName = 'home';
